import { useEffect, useState } from "react";
import {
  CAPTCHA_CONSENT_EVENT,
  hasCaptchaConsent,
  setCaptchaConsent,
  syncCaptchaConsentAcrossTabs,
} from "./captcha-consent";

/** Independent from analytics and from permission to contact the visitor. */
export function CaptchaPreference() {
  const [granted, setGranted] = useState(false);
  useEffect(() => {
    syncCaptchaConsentAcrossTabs();
    const sync = () => setGranted(hasCaptchaConsent());
    sync();
    window.addEventListener(CAPTCHA_CONSENT_EVENT, sync);
    window.addEventListener("focus", sync);
    return () => {
      window.removeEventListener(CAPTCHA_CONSENT_EVENT, sync);
      window.removeEventListener("focus", sync);
    };
  }, []);
  return (
    <div className="space-y-2 text-sm font-body">
      <label className="flex items-start gap-2">
        <input
          type="checkbox"
          checked={granted}
          onChange={(event) => setCaptchaConsent(event.target.checked)}
        />
        <span>
          Allow Google reCAPTCHA cookies for additional spam protection
          (optional).
        </span>
      </label>
      <p>
        You can still send this form without allowing these cookies. Withdrawing
        this permission reloads the page if Google has loaded and stops future
        use; cookies already stored on Google’s domain cannot be removed by this
        site.
      </p>
      <p>
        When enabled, this form is protected by reCAPTCHA and the Google{" "}
        <a
          className="underline"
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{" "}
        and{" "}
        <a
          className="underline"
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>{" "}
        apply.
      </p>
    </div>
  );
}
